export const appLinks = {
    client: {
        apple: 'https://apps.apple.com/app/id6745751830',
        google: 'https://play.google.com/store/apps/details?id=blue.muffin.polako.client',
    },
    tickets: {
        apple: 'https://apps.apple.com/app/id6739801654',
        google: 'https://play.google.com/store/apps/details?id=blue.muffin.polako.tickets',
        web: 'https://ticket-tool.polakohedonist.club',
    },
};
